import { Group, Stack } from "@mantine/core";
import { IconFileText } from "@tabler/icons-react";
import { generatePath } from "react-router";
import { ROUTES } from "../../../../../../routes";
import type { MeteringConceptTodo } from "../../../../../../utils/backend-types";
import { AnchorLink } from "../../../../../AnchorLink/AnchorLink";
import "./MeteringConceptDocumentLinks.scss";

interface MeteringConceptDocumentLinksProps {
  projectId: string;
  todos?: Array<MeteringConceptTodo>;
}

function MeteringConceptDocumentLinks({
  projectId,
  todos
}: MeteringConceptDocumentLinksProps) {
  if (!todos || todos.length === 0) {
    return null;
  }

  const linkWithProjectId = generatePath(ROUTES.todos.entry, {
    projectId
  });

  return (
    <Stack className="MeteringConceptDocumentLinks" mt="sm">
      {todos.map((todo) => (
        <Group align="center" className="mcd-link" gap="xs" key={todo.id}>
          <IconFileText size="1.2em" />
          <AnchorLink href={linkWithProjectId + "/" + todo.id}>
            Zu den Unterlagen
          </AnchorLink>
        </Group>
      ))}
    </Stack>
  );
}

export { MeteringConceptDocumentLinks };
